module.exports = __webpack_public_path__ + "img/medium-ball-violet.92a40285.svg";